import {
    RegionsEnum,
    AccessoriesPageAmDocument,
    AccessoriesPageAmQuery,
    AccessoriesPageAmQueryVariables,
    AccessoriesPageApDocument,
    AccessoriesPageApQuery,
    AccessoriesPageApQueryVariables,
    AccessoriesPageEuDocument,
    AccessoriesPageEuQuery,
    AccessoriesPageEuQueryVariables,
} from 'src/generated/operations.ts';
import { removeDuplicateFragments } from 'src/utils/de-dupe-fragments.ts';
import { DocumentNode } from 'graphql/language/ast';
import { FilterConfig } from 'src/utils/composeFilter.ts';
import { getActuatorsPageConfig } from 'src/modules/actuators/ActuatorsPageMapping.ts';

export type AccessoriesPageData = Omit<
AccessoriesPageEuQuery | AccessoriesPageApQuery | AccessoriesPageAmQuery,
'__typename'
>;
export type AccessoriesPageVariables = Omit<
AccessoriesPageEuQueryVariables | AccessoriesPageApQueryVariables | AccessoriesPageAmQueryVariables, '__typename'
>;

export type AccessoriesPageConfig = {
    mainFilterConfig: FilterConfig;
    query: DocumentNode;
    actuatorsFilterConfig: FilterConfig;
    additionalFilterConfig: FilterConfig;
}

export const getAccessoriesPageConfig = (region: RegionsEnum): AccessoriesPageConfig | null => {
    const actuatorsPageConfig = getActuatorsPageConfig(region);
    if (actuatorsPageConfig === null) {
        throw new Error('No Valves Page Config');
    }
    const {
        mainFilterConfig,
        additionalFilterConfig,
        filterConfig: actuatorsFilterConfig,
    } = actuatorsPageConfig;
    if (region === RegionsEnum.Eu) {
        return {
            query: removeDuplicateFragments(AccessoriesPageEuDocument),
            actuatorsFilterConfig,
            mainFilterConfig,
            additionalFilterConfig,
        };
    }
    if (region === RegionsEnum.Ap) {
        return {
            query: removeDuplicateFragments(AccessoriesPageApDocument),
            actuatorsFilterConfig,
            mainFilterConfig,
            additionalFilterConfig,
        };
    }
    if (region === RegionsEnum.Am) {
        return {
            query: removeDuplicateFragments(AccessoriesPageAmDocument),
            actuatorsFilterConfig,
            mainFilterConfig,
            additionalFilterConfig,
        };
    }
    return null;
};
